import { Link, Typography } from "@mui/material";

export const Copyright = (props) => {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://atxmedical.com.au/services/itx-pacs/">
        ATX
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
      <br />
      <Link color="inherit" href="/privacy-policy">
        privacy policy
      </Link>
    </Typography>
  );
};
